module.exports = __webpack_public_path__ + "static/media/guante.310b41e3.png";